export default __webpack_public_path__ + "static/media/ayuda-inac.4afe7291.svg";